import { all, put, call, takeLatest, select } from "redux-saga/effects";
import { getErrorMessage } from "utils/sagasErrorHandler";
import { INITIAL_SCRAPE_TASKS_STATISTIC_OFFSET } from "modules/Scheduler/constants";
import { buildAll, getLabelsByType } from "utils";
import { getCountSchedulerListRequest } from "modules/Scheduler/services/InitialScrapeTasks/api";
import { mergeScheduleDialog } from "modules/Scheduler/services/InitialScrapeTasks/actions";
import { scheduleDialogSelector } from "modules/Scheduler/services/InitialScrapeTasks/selectors";
import { schedulerStatisticSelector } from "modules/Scheduler/services/InitialScrapeTasksStatistic/selectors";
import { getInitialScrapeTasksStatisticRequest } from "modules/Scheduler/services/InitialScrapeTasksStatistic/api";
import {
    getInitialScrapeTasksStatistic,
    getInitialScrapeTasksStatisticSuccess,
    getInitialScrapeTasksStatisticError,
    changeTimePeriodReschedule
} from "modules/Scheduler/services/InitialScrapeTasksStatistic/actions";

//Workers
function* schedulerStatistic(filterParams, data = [], count){
    try {
        const { isOpen } = yield select(scheduleDialogSelector);
        const { initial_scrape_tasks } = yield call(getInitialScrapeTasksStatisticRequest, filterParams);
        const newData = [ ...data, ...initial_scrape_tasks ];

        const percent = (newData.length * 100 / count).toFixed(2);
        yield put(mergeScheduleDialog({ completionPercentage: percent }));

        if(newData.length !== count && isOpen){
            const newFilterParams = { ...filterParams };
            newFilterParams.offset = Number(newFilterParams.offset) + Number(INITIAL_SCRAPE_TASKS_STATISTIC_OFFSET);

            return yield schedulerStatistic(newFilterParams, newData, count);
        }

        return newData;
    } catch (error) {
        getErrorMessage(error);
    }
}

function* handleGetInitialScrapeTasksStatistic ({ payload }) {
    try {
        const { receiver_code } = payload;
        let starts = {};
        const filterData = {
            ...payload,
            offset: 0,
            limit: 1000
        };
        const labels = yield call(getLabelsByType, 1440); //per 24 h
        const { count } = yield call(getCountSchedulerListRequest, payload);
        starts[receiver_code] = yield schedulerStatistic(filterData, [], count);

        const statistic = yield call(
            buildAll,
            {
                codes: [ receiver_code ],
                labels,
                starts
            }
        );
        yield put(getInitialScrapeTasksStatisticSuccess({ codes: [ receiver_code ], starts, statistic, labels }));
    } catch (error) {
        yield put(getInitialScrapeTasksStatisticError());
        getErrorMessage(error);
    }
}

function* handleChangeTimePeriodInitialScrapeTasksStatistic ({ payload }) {
    try {
        const { starts, codes } = yield select(schedulerStatisticSelector);

        if(codes.length){
            const labels = yield call(getLabelsByType, payload);
            const statistic = yield call(buildAll, { codes, labels, starts, timePeriod: payload });
            yield put(getInitialScrapeTasksStatisticSuccess({ statistic }));
        }
    } catch (error) {
        getErrorMessage(error);
    }
}

// Watchers
export function* schedulersStatisticSagas() {
    yield all([
        yield takeLatest(getInitialScrapeTasksStatistic, handleGetInitialScrapeTasksStatistic),
        yield takeLatest(changeTimePeriodReschedule, handleChangeTimePeriodInitialScrapeTasksStatistic)
    ]);
}
